import React  from 'react';

import { Link, useHistory, useLocation } from "react-router-dom"
import { LinkHelper, ShareHelper } from "../../helpers";
import { getApiUrl } from '../../core/config/api';

const PageListItem2 = ({
    selectedId,
    onSelect,
    className = '',
    page
}) => {
    const history = useHistory()
    const location = useLocation()

    const onClick = (e) => {
        e.preventDefault()
        history.push(page.url)
    }

    const imageUrl = getApiUrl(`/media/${page?.image_other || page?.image}`);

    const onShareClick = (e) => {
        e.preventDefault()

        const link = page?.datasheet
  ? LinkHelper.link(getApiUrl(`/media/${page?.datasheet}`))
  : LinkHelper.link(location.pathname);
        ShareHelper.share(link)
    }

    return (
        <div className={`page ${className}`}>
            { page?.tags?.length > 0 && (
                <div className="tags">
                    { page?.tags?.map(t => {
                        return <span key={t?.name?.en}>{t?.name?.en}</span>
                    })}
                </div>
            )}

            <img src={imageUrl} style={{
                width: '100%',
                aspectRatio: '19/10',
            }}/>

            <div className="text d-flex flex-column justify-content-between">
                <div>
                    <Link to={page?.url}><h3 className="mt-2">{ page?.title }</h3></Link>

                    <p>
                        { page?.description }
                    </p>
                </div>

                <div className="d-flex">
                    {onSelect && (
                        <button className="me-1" onClick={() => onSelect(page)}>
                            {selectedId == page?.id ? 'Selected' : 'Select'}
                        </button>
                    )}

                    <Link to={page?.url}>
                        <button className="next">Read More</button>
                    </Link>

                    {!onSelect && (
                        <button className="mx-1 share" onClick={onShareClick} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default PageListItem2
